import type { DealStatus } from '../service/types';

/**
 * Decides the initial status for a newly created deal. When `starts_at` is in
 * the future we stage the deal as `paused` so the backend scheduler auto-flips
 * it to `active` at start time; otherwise it goes live immediately.
 */
export function resolveCreateStatus(
  startsAtIso: string | null | undefined,
  now: number = Date.now(),
): DealStatus {
  if (!startsAtIso) return 'active';
  const startsAtMillis = new Date(startsAtIso).getTime();
  if (!Number.isFinite(startsAtMillis)) return 'active';
  return startsAtMillis > now ? 'paused' : 'active';
}
